import { WSPage, WSPageToolbar } from "@wingspanhq/fe-component-library";
import { Redirect, Route, Switch } from "react-router-dom";
import { Tabs } from "../../../../components/Tabs";
import { useFeatureFlags } from "../../../../query/hooks/useFeatureFlags";
import { RouteAddFundingMethod } from "./routes/RouteAddFundingMethod";
import { RouteManageFundingMethod } from "./routes/RouteManageFundingMethod";
import { RouteMethod } from "./routes/RouteMethod";
import { RoutePayables } from "./routes/RoutePayables";
import { RouteSchedule } from "./routes/RouteSchedule";
import { RouteWorkLogs } from "./routes/RouteWorkLogs";
import { RouteAddEmailSnippet } from "./routes/RouteAddEmailSnippet";
import { RouteEmailInvites } from "./routes/RouteEmailInvites";
import {
  PATH_SETTINGS_EMAIL_INVITES,
  PATH_SETTINGS_EMAIL_INVITES_ADD_SNIPPET,
  PATH_SETTINGS_EMAIL_INVITES_EDIT_SNIPPET,
  PATH_SETTINGS_PAYROLL_ADD_FUNDING_METHOD,
  PATH_SETTINGS_PAYROLL_MANAGE_FUNDING_METHOD,
  PATH_SETTINGS_PAYROLL_METHOD,
  PATH_SETTINGS_PAYROLL_PAYABLES,
  PATH_SETTINGS_PAYROLL_SCHEDULE,
  PATH_SETTINGS_PAYROLL_WORK_LOGS
} from "../../paths";

export const RoutePayroll: React.FC = () => {
  const featureFlags = useFeatureFlags();
  const isWorkLogReviewWorkflow = featureFlags.data?.workLogReviewWorkflow;

  return (
    <WSPage>
      <WSPageToolbar title="Send payments settings" />

      <Tabs
        mb="2XL"
        tabs={[
          {
            label: "Payroll funding method",
            path: PATH_SETTINGS_PAYROLL_METHOD
          },
          ...(isWorkLogReviewWorkflow
            ? [
                {
                  label: "Work logs settings",
                  path: PATH_SETTINGS_PAYROLL_WORK_LOGS
                }
              ]
            : []),
          {
            label: "Payables settings",
            path: PATH_SETTINGS_PAYROLL_PAYABLES
          },
          {
            label: "Payroll schedule",
            path: PATH_SETTINGS_PAYROLL_SCHEDULE
          },
          {
            label: "Email invites",
            path: PATH_SETTINGS_EMAIL_INVITES
          }
        ]}
      />

      <Switch>
        <Route path={PATH_SETTINGS_PAYROLL_METHOD} component={RouteMethod} />
        {isWorkLogReviewWorkflow && (
          <Route
            path={PATH_SETTINGS_PAYROLL_WORK_LOGS}
            component={RouteWorkLogs}
          />
        )}
        <Route
          path={PATH_SETTINGS_PAYROLL_SCHEDULE}
          component={RouteSchedule}
        />
        <Route
          path={PATH_SETTINGS_PAYROLL_PAYABLES}
          component={RoutePayables}
        />

        <Route
          path={PATH_SETTINGS_PAYROLL_MANAGE_FUNDING_METHOD}
          component={RouteManageFundingMethod}
        />
        <Route
          path={PATH_SETTINGS_PAYROLL_ADD_FUNDING_METHOD}
          component={RouteAddFundingMethod}
        />
        <Route
          path={[
            PATH_SETTINGS_EMAIL_INVITES_ADD_SNIPPET,
            PATH_SETTINGS_EMAIL_INVITES_EDIT_SNIPPET
          ]}
          component={RouteAddEmailSnippet}
        />
        <Route
          path={PATH_SETTINGS_EMAIL_INVITES}
          component={RouteEmailInvites}
        />

        <Redirect to={PATH_SETTINGS_PAYROLL_METHOD} />
      </Switch>
    </WSPage>
  );
};
